import PropTypes from "prop-types";
import { ToolbarGroup } from "./toolbar-group.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  expand: PropTypes.bool,
  flex: PropTypes.number
};
const defaultProps = {
  expand: false,
  flex: 1
};
ToolbarGroup.propTypes = propTypes;
ToolbarGroup.defaultProps = defaultProps;
export {
  ToolbarGroup
};
